import { render } from "./my-grid.vue?vue&type=template&id=5f6ef750"
import script from "./my-grid.vue?vue&type=script&lang=js"
export * from "./my-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__